import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { experimentsReducer } from '@wix/wix-experiments-redux';
import profileReducer from './ProfilePage/profilePageReducer';
import exploreReducer from './Explore/exploreReducer';
import filtersReducer from './Explore/Filters/filtersReducer';
import userActionsReducer from './Header/userActionsReducer';
import initialDataReducer from './initialDataReducer';

export default history =>
  combineReducers({
    router: connectRouter(history),
    profile: profileReducer,
    filters: filtersReducer,
    explore: exploreReducer,
    experiments: experimentsReducer,
    userActions: userActionsReducer,
    initialData: initialDataReducer,
  });
